import { useValidDealerItemContext } from "../context/DealerItemProviderContext.tsx";

/** The phone number from the user's profile, in the whitespace-free format the phone fields keep. */
export const usePrefilledPhoneNumber = (): string => {
  const {
    external: { userPhoneNumber },
  } = useValidDealerItemContext();

  return userPhoneNumber?.replace(/\s/g, "") ?? "";
};
